<template lang="pug">
  section.ParagraphQuizz
    .ParagraphQuizz_wrapper

      .QuizzTitle

        .QuizzTitle_quizz {{ $t('tour.quizz.quizz') }}

        .sep-long
        p.QuizzTitle_title {{ $t('tour.quizz.title') }}
        .sep-long

      .ParagraphQuizz_questions

        ParagraphQuizzQuestion(
          v-for="(q, index) in item.questions"
          :key="q.id"
          :item="q",
          :isValidated="isValidated"
        )

      .ParagraphQuizz_footer(v-if="!isValidated")

        .sep-long
        ButtonSimple(@click.native="onSubmitHandler") {{ $t('tour.quizz.discover') }}
        .sep-long

</template>

<script>

import Paragraph from '@/components/paragraphs/Paragraph'
import ParagraphQuizzQuestion from '@/components/paragraphs/ParagraphQuizzQuestion'
import ButtonSimple from '@/components/common/ButtonSimple'

export default {
  props: ['item'],
  data () {
    return {
      isValidated: false
    }
  },
  components: { Paragraph, ParagraphQuizzQuestion, ButtonSimple },
  methods: {
    onSubmitHandler (e) {
      e.preventDefault()
      this.isValidated = true
    }
  }
}

</script>

<style lang="stylus" scoped>

.ParagraphQuizz

  background-color $black
  color $beige

  &_wrapper
    box-sizing border-box
    max-width 1100px
    padding 20px 20px
    margin 0 auto

    @media $mq_m
      padding 6.875em 20px

  &_footer

    flex-direction row
    display flex
    justify-content center
    align-items center

    .ButtonSimple

      margin auto 15px

  .ParagraphQuizz_questions

    margin 30px auto
    width 100%
    max-width 720px

    @media $mq_m
      margin 9.0625vw auto

  .sep-long

    margin auto
    opacity: 0.3;
    width calc(100% - 700px)
    height 1px
    background-color $beige

  .QuizzTitle

    text-align center
    position relative
    width 100%
    display flex
    flex-direction row
    justify-content center
    align-items center
    height 20vw

    @media $mq_m
      height 12.5vw

    &_title

      font-weight 600
      margin auto 15px
      white-space: nowrap;
      text-transform uppercase
      letter-spacing: 5px;
      text-align: center;

      @media $mq_s_only
        font-size 10px

    &_quizz

      opacity: 0.1;
      font-family: 'Sectra Display'
      font-size: 20vw;
      letter-spacing: 0.1em;
      position absolute
      top 44%
      left 50%
      transform translate(-50%,-50%)

      @media $mq_m
        top 40%
        font-size: 12.5vw;

</style>
